import { render } from "./indexAddpost.vue?vue&type=template&id=fd03713c"
import script from "./indexAddpost.vue?vue&type=script&lang=js"
export * from "./indexAddpost.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__